export const __PROD__ = 'production'
export const __ACCEPTANCE__ = 'accp'
export const __TEST__ = 'base'
export type DeploymentEnvironment = typeof __PROD__ | typeof __TEST__ | typeof __ACCEPTANCE__

// Like the inlined variable during the compile step but 'visible' for TS
// https://reactjs.org/docs/codebase-overview.html#development-and-production
export const __DEV__ = process.env.NODE_ENV === 'development'
